import { render, staticRenderFns } from "./DashboardFeaturePanel.vue?vue&type=template&id=0944fef6&scoped=true&"
import script from "./DashboardFeaturePanel.vue?vue&type=script&lang=js&"
export * from "./DashboardFeaturePanel.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFeaturePanel.vue?vue&type=style&index=0&id=0944fef6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0944fef6",
  null
  
)

export default component.exports